export const environment = {
  remote: false,
  realm: 'tamwilcom-recette',
  url: 'https://keycloak.neosys.business/',
  clientId: 'tamwilcom-front',

  SERVER_REFERENTIEL_API_URL: 'https://recette-tamwilcom-referentiel.neosys.business',
  SERVER_EDITION_API_URL: 'https://recette-tamwilcom-edition.neosys.business',
  SERVER_UTILISATEUR_API_URL: 'https://recette-tamwilcom-utilisateur.neosys.business',
  SERVER_NOTIFICATION_API_URL: 'https://recette-tamwilcom-notification.neosys.business',
  SERVER_REGLE_API_URL: 'https://recette-tamwilcom-regle.neosys.business',
  SERVER_CHARGEMENT_API_URL: 'https://recette-tamwilcom-chargement.neosys.business',
  SERVER_READ_API_URL: 'https://recette-tamwilcom-backoffice.neosys.business',
  SERVER_WORKFLOW_API_URL: 'https://recette-tamwilcom-workflow.neosys.business',
  SERVER_BACKOFFICE_API_URL: 'https://recette-tamwilcom-backoffice.neosys.business',
  SERVER_PLANIFICATION_API_URL: 'https://recette-tamwilcom-planification.neosys.business',
  SERVER_MEJ_API_URL: 'https://recette-tamwilcom-mej.neosys.business',
  SERVER_CFT_API_URL:  'https://recette-tamwilcom-cft.neosys.business',
  SERVER_SOCLE_API_URL: 'https://recette-tamwilcom-backoffice.neosys.business',
  SIGNALR_HUB_URL: 'https://recette-tamwilcom-backoffice.neosys.business',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
